import { LoginDetails, OtpLogin } from '../types/auth';
import { getApi, noAuthPostApi,postApi} from './apis';

export const getSsoStatus = (customerCode: string) =>
  getApi(`customer/${customerCode}`, {
    headers: { Authorization: undefined },
  });

/**
 * Creates a new user login by sending a POST request to the 'user/login' endpoint with the provided data.
 */
export const logIn = (data: LoginDetails) =>
  noAuthPostApi(`User/login`, data);

/**
 * Creates a reset request by sending a POST request to the specified API endpoint.
 */
export const createResetRequest = (data: any) => 
      noAuthPostApi(`User/reset-password-request`, data );


/**
 * Creates a request to reset the password using the provided data.
 */
export const resetPassword = (data: any) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: 'Bearer undefined', // Include the one-time token in the Authorization header
  };

  return postApi('User/reset-password', data, { headers });
};

/**
 * post request for user otp login
 */
export const userOtpLogin = (data: OtpLogin) =>
  noAuthPostApi(`User/verify-mfa`, data);



